// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"fy","newsTag":"fy","dafalut":"fz","shehui":"fA","caiwu":"fB","keji":"fC","lingshou":"fD","gongzuo":"fE"};